import UAParser from 'ua-parser-js';

const getLabelFromUserAgent = (userAgent: string) => {
  const ua = UAParser(userAgent);
  const device = ua.device.model ?? 'Unknown';
  const os = ua.os.name ?? 'Unknown';
  const os_version = ua.os.version ?? 'Unknown';
  const browser = ua.browser.name ?? 'Unknown';
  const browser_version = ua.browser.version ?? 'Unknown';
  return `${device} ${os} (${os_version}) ${browser} (${browser_version})`;
};

const createUUIDFromUserAgent = (userAgent: string): string => {
  let uuid = userAgent.replace(/[^a-z0-9]/gi, '-');
  uuid = uuid.length >= 36 ? uuid.substring(0, 36) : uuid.padEnd(36, '-');
  return uuid;
};

export const deviceInfoFromUserAgent = (userAgent: string) => ({
  label: getLabelFromUserAgent(userAgent),
  // UUID from user agent
  udid: createUUIDFromUserAgent(userAgent),
});
